import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSuitcaseWork"><Path d="M21.5 20.5V6.5H2.5V20.5H21.5Z" stroke="currentColor"/><Path d="M7.5 6.5V2.5H16.5V6.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseWork;
